var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-sidebar",
    {
      staticClass: "pila-sidebar",
      attrs: {
        type: "is-light",
        fullheight: true,
        mobile: "fullwidth",
        overlay: true,
        "can-cancel": false,
      },
      model: {
        value: _vm.showSidebar,
        callback: function ($$v) {
          _vm.showSidebar = $$v
        },
        expression: "showSidebar",
      },
    },
    [
      _c("div", { staticClass: "has-background-primary-dark sticky-top" }, [
        _c("div", { staticClass: "first-row p-3" }, [
          _c("div", { staticClass: "is-pulled-right ml-2 mb-2" }, [
            _c(
              "a",
              { staticClass: "has-text-white", on: { click: _vm.close } },
              [_c("i", { staticClass: "fas fa-times fa-lg" })]
            ),
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "subtitle is-7 has-text-white" }, [
            _vm._v(
              "Pila de documentos - " +
                _vm._s(_vm.docStack.length) +
                " documento" +
                _vm._s(_vm.docStack.length > 1 ? "s" : "")
            ),
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "title is-6 has-text-white" }, [
            _vm._v("Documentos a firmar"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "section" },
        [
          _c("h3", { staticClass: "title is-6" }, [_vm._v("Paso 1")]),
          _vm._v(" "),
          _c("h3", { staticClass: "subtitle is-6" }, [
            _vm._v("Pila de documentos"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.docStack, function (doc) {
            return _c(
              "div",
              { key: doc.id, staticClass: "card is-radiusless" },
              [
                _c("header", { staticClass: "card-header" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-header-title is-400 is-flex is-flex-direction-row is-align-items-flex-start",
                    },
                    [
                      _c("p", { staticClass: "mr-3" }, [
                        _c("i", {
                          staticClass: "fas fa-fw",
                          class:
                            doc.tipo_documento_id == "carpeta"
                              ? "fa-folder"
                              : doc.tipo_documento_id == "recibo"
                              ? "fa-dollar-sign"
                              : "fa-file",
                        }),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "is-flex-grow-1 break-word" }, [
                        _vm._v(_vm._s(doc.nombre)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card-header-icon",
                      attrs: { "aria-label": "more options" },
                    },
                    [
                      _c("button", {
                        staticClass: "delete is-pulled-right",
                        on: {
                          click: function ($event) {
                            return _vm.removeFromPila(doc.id)
                          },
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _c("div", { staticClass: "card is-radiusless" }, [
            _c("header", { staticClass: "card-header" }, [
              _c(
                "div",
                {
                  staticClass:
                    "card-header-title is-400 has-text-centered is-flex is-flex-direction-row is-align-items-flex-start",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "is-size-7 is-flex-grow-1",
                      on: {
                        click: function ($event) {
                          return _vm.cleanPila()
                        },
                      },
                    },
                    [_vm._v("Limpiar fila")]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("h3", { staticClass: "title is-6" }, [_vm._v("Paso 2")]),
          _vm._v(" "),
          _c("h3", { staticClass: "subtitle is-6" }, [
            _vm._v("Seleccione el firmador a utilizar"),
          ]),
          _vm._v(" "),
          _vm.user && _vm.user.firmadores_habilitados.signar
            ? _c(
                "div",
                {
                  staticClass:
                    "box is-flex is-flex-direction-row is-align-items-center",
                },
                [
                  _c(
                    "div",
                    { staticClass: "is-flex-grow-1" },
                    [
                      _c(
                        "b-radio",
                        {
                          attrs: { "native-value": "signar" },
                          model: {
                            value: _vm.firmadorSelected,
                            callback: function ($$v) {
                              _vm.firmadorSelected = $$v
                            },
                            expression: "firmadorSelected",
                          },
                        },
                        [_c("b", [_vm._v("Firmador Desktop Signar® v1")])]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "image firmador-select",
                    attrs: { src: "/statics/signar-logo.svg", alt: "" },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.user && _vm.user.firmadores_habilitados.pfdrar
            ? _c(
                "div",
                {
                  staticClass:
                    "box is-flex is-flex-direction-row is-align-items-center",
                },
                [
                  _c(
                    "div",
                    { staticClass: "is-flex-grow-1" },
                    [
                      _c(
                        "b-radio",
                        {
                          attrs: { disabled: "", "native-value": "pfdrar" },
                          model: {
                            value: _vm.firmadorSelected,
                            callback: function ($$v) {
                              _vm.firmadorSelected = $$v
                            },
                            expression: "firmadorSelected",
                          },
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "has-text-danger is-size-7" },
                            [_vm._v("No disponible")]
                          ),
                          _vm._v(" "),
                          _c("b", [
                            _vm._v(
                              "Plataforma de Firma Digital Remota - Secretaria de Modernización - Argentina"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "image firmador-select",
                    attrs: { src: "/statics/pfdrar-logo.png", alt: "" },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "box is-flex is-flex-direction-row is-align-items-center",
            },
            [
              _c(
                "div",
                { staticClass: "is-flex-grow-1" },
                [
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": "signar_v3" },
                      model: {
                        value: _vm.firmadorSelected,
                        callback: function ($$v) {
                          _vm.firmadorSelected = $$v
                        },
                        expression: "firmadorSelected",
                      },
                    },
                    [
                      _vm._v(
                        "\n            Signar® Firmador Integrable v3\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "buttons is-centered" }, [
            _c(
              "button",
              {
                staticClass: "button is-link",
                attrs: {
                  disabled: !_vm.firmadorSelected || !_vm.docStack.length,
                },
                on: {
                  click: function ($event) {
                    return _vm.goFirmar()
                  },
                },
              },
              [_vm._v("Firmar documentos")]
            ),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }